module.exports = __webpack_public_path__ + "static/media/african-independent-mobile.1eda9274.svg";